module.exports = "/virtual-football-league/img/amblems/right/Germany/Fake_Dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Germany/Fake_Dortmund.png
// module id = 2139
// module chunks = 4